import { render } from "./IconTrekSuspensionFront.vue?vue&type=template&id=ab42ecb2"
import script from "./IconTrekSuspensionFront.vue?vue&type=script&lang=js"
export * from "./IconTrekSuspensionFront.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__